<div class="filter-ranking-component">
  <div class="title-box">
    <span class="subheading-01-semi-bold">Filtros</span>
    <qr-button
      [config]="buttonClose"
      (click)="emitCloseFilter()"
      matTooltip="Cerrar filtros"
    ></qr-button>
  </div>
  <div class="filters-items">
    <div class="item-box">
      <div class="title subheading-01-semi-bold">Región</div>
      <div class="content" id="region-filter">
        <qr-button
          *ngFor="let button of regionsButtons; let i = index"
          [id]="i"
          [config]="button"
          (click)="toggleRegion(i)"
        ></qr-button>
      </div>
    </div>

    <div class="item-box">
      <div class="title subheading-01-semi-bold">
        Sub-región
        <span>{{listSubregionsSelected?.length}} de {{listSubregions.length}}</span>
      </div>
      <div class="content">
        <qr-dropdown
          [config]="subregionMultiple"
          [selected]="listSubregionsSelected"
          (change)="onSubregionsChange($event)"
        ></qr-dropdown>
      </div>
    </div>

    <div class="item-box" *ngIf="rangesViewAnt">
      <div class="title subheading-01-semi-bold">Antigüedad de oficina</div>
      <div class="content" id="range">
        <ngx-slider
          [(value)]="antiquityOfficeFromValue"
          [(highValue)]="antiquityOfficeToValue"
          [options]="antiquityOfficeSliderOptions"
          (valueChange)="rangeFromOfficeYears($event)"
          (highValueChange)="rangeToOfficeYears($event)"
        ></ngx-slider>
      </div>
    </div>

    <div class="item-box" *ngIf="rangesViewAgent">
      <div class="title subheading-01-semi-bold">Cantidad de agentes</div>
      <div class="content" id="range">
        <ngx-slider
          [(value)]="amountAgentsFromValue"
          [(highValue)]="amountAgentsToValue"
          [options]="amountAgentsSliderOptions"
          (valueChange)="rangeFromAgents($event)"
          (highValueChange)="rangeToAgents($event)"
        ></ngx-slider>
      </div>
    </div>

    <div class="item-box">
      <div class="title subheading-01-semi-bold">Oficinas</div>
      <div class="content">
        <qr-input-autocomplete
        *ngIf="this.listAutocompleteOffices.length > 0"
          [config]="inputAutocompleteOffices"
          (selectedChange)="inputAutocompleteChange($event)"
        ></qr-input-autocomplete>
        <div class="offices-selected" *ngIf="officesSelected.length > 0">
          <qr-chip
            *ngFor="let item of officesSelected"
            [config]="chipOffice"
            [value]="item"
            (dispatchClean)="cleanChip($event)"
          ></qr-chip>
        </div>
      </div>
    </div>
  </div>
</div>
